/**
 * AUTH SERVICE — API calls for login/logout
 *
 * WHY a separate service? Components should NOT contain fetch() calls directly.
 * The Login.svelte component calls authService.login(). If the backend URL
 * changes, or you swap from REST to GraphQL, you update THIS file only.
 *
 * MOCK MODE: Since we have no real backend, this file includes a mock
 * implementation that simulates a 500ms network delay and returns fake
 * JWT tokens. When you have a real API, delete the mock and uncomment
 * the real httpClient calls.
 */
// ---- MOCK DATA (delete this block when you have a real backend) ----
const MOCK_USERS = {
    'admin@demo.com': {
        password: 'admin123',
        user: {
            id: '1',
            email: 'admin@demo.com',
            fullName: 'Admin User',
            role: 'admin',
            avatarUrl: undefined,
        },
    },
    'user@demo.com': {
        password: 'user123',
        user: {
            id: '2',
            email: 'user@demo.com',
            fullName: 'Regular User',
            role: 'user',
            avatarUrl: undefined,
        },
    },
};
function generateFakeToken() {
    // Creates a random base64 string that looks like a JWT (for demo purposes)
    return btoa(Math.random().toString(36) + Date.now().toString(36));
}
async function mockDelay(ms = 800) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
// ---- SERVICE FUNCTIONS ----
export async function login(credentials) {
    // --- MOCK IMPLEMENTATION (replace with real API call) ---
    await mockDelay();
    const mockEntry = MOCK_USERS[credentials.email];
    if (!mockEntry || mockEntry.password !== credentials.password) {
        throw new Error('Email atau password salah.');
    }
    return {
        accessToken: generateFakeToken(),
        refreshToken: generateFakeToken(),
        user: mockEntry.user,
        expiresIn: 3600,
    };
    // --- REAL IMPLEMENTATION (uncomment when backend is ready) ---
    // const { data } = await httpClient.post<ApiResponse<AuthResponse>>(
    //   ENDPOINTS.AUTH.LOGIN,
    //   credentials
    // );
    // return data.data;
}
export async function logout() {
    // --- MOCK: nothing to call ---
    await mockDelay(200);
    // --- REAL IMPLEMENTATION ---
    // await httpClient.post(ENDPOINTS.AUTH.LOGOUT);
}
//# sourceMappingURL=auth.service.js.map